
















































































import Vue from 'vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import {
  DocuSignTemplateModel,
  DocuSignTemplateConfigurationModel,
  ArenaSignTemplateSearchModel,
  Dictionary,
  Configuration
} from '@/types';
import { RouteRegEx } from '@/types/enums';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import {
  ComponentHelper,
  MTablehelper,
  RouteHelpers,
  confirmationHelper,
  FormFieldValidation,
  ObjectHelper
} from '@/mixins';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'DocuSignTemplateAdditionalDocumentManagement',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper, FormFieldValidation, ObjectHelper],
  data() {
    return {
      pageIsLoading: true,
      submitIsLoading: false,
      isLoading: false,
      fields: [
        {
          'additionalDocumentFile.fileName': {
            label: 'File Name',
            sortable: true
          }
        },
        {
          'additionalDocumentFile.description': {
            label: 'Description',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],

      hasError: false,
      errorMessage: '',
      docuSignTemplateConfigurationModel: {} as DocuSignTemplateConfigurationModel,
      docuSignTemplate: {} as DocuSignTemplateModel,
      tableStateKey: MTablehelper.Constants.TableStoreKeys.DocuSignTemplateAdditionalDocuments
    };
  },
  methods: {
    async getData(this: any) {
      this.isLoading = true;
      try {
        this.docuSignTemplatesConfigurationModel = await DocuSignConfigurationService.getTemplateConfigurationAsync({
          documentTypeId: this.documentTypeId,
          templateId: this.templateId
        } as ArenaSignTemplateSearchModel);
        this.docuSignTemplate = this.docuSignTemplatesConfigurationModel.template;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    navigateToEditTemplateAdditionalDocument(this: any, id: number) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.id = id;
      this.onTableStateFieldUpdated('selectedPk', id);
      this.$router.push({
        name: Configuration.DocuSign.TemplateAdditionalDocument.Edit.name,
        params: param
      });
    },
    navigateToAddTemplateAdditionalDocument(this: any, id: number) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      this.$router.push({
        name: Configuration.DocuSign.TemplateAdditionalDocument.Add.name,
        params: param
      });
    },
    navigateToEditTemplate(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.id = this.templateId;
      this.$router.push({
        name: Configuration.DocuSign.Template.Edit.name,
        params: param
      });
    },
    async deleteTemplateAdditionalDocument(this: any, id: number) {
      const result = await this.hasDeleteConfirmedAsync(
        this.$bvModal,
        'Are you sure you want to delete the Additional Document?'
      );
      if (result) {
        try {
          this.isLoading = true;
          await DocuSignConfigurationService.deleteTemplateAdditionalDocumenAsync(id);
          SnotifyConfiguration.showSuccess('Additional Document deleted successfully.');
          await this.getData();
        } catch (error) {
          this.$log('Error deleting Additional Document');
        } finally {
          this.isLoading = false;
        }
      }
    },
    resetViewState(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.DocuSignTemplateAdditionalDocuments);
      if (!canKeepState) {
        this.resetMTableState(this.tableStateKey);
      }
    },
    async initialise(this: any) {
      try {
        this.pageIsLoading = true;
        this.resetViewState();
        await this.getData();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pageIsLoading = false;
      }
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    },
    tableHeaderText(this: any) {
      return this.docuSignTemplate?.template
        ? `Additional Documents (${this.docuSignTemplate.template})`
        : 'Additional Documents';
    }
  },
  components: {
    MStoreTable,
    LoadingSpinner
  },
  mounted() {
    this.initialise();
  }
});
